import React from 'react';
import PropTypes from 'prop-types';
import ClearIcon from '@tradera/tradera-ui/icons/clear.svg?jsx';

const Tag = ({ text, onClick }) => {
    const iconStyle = {
        marginLeft: '0.8rem',
        marginRight: '-0.8rem'
    };
    return (
        <button
            type="button"
            className="btn btn-dark btn-sm m-1"
            onClick={() => onClick()}>
            {text}
            <ClearIcon
                style={iconStyle}
                className="icon icon-md icon-white icon-after"
            />
        </button>
    );
};

Tag.propTypes = {
    text: PropTypes.string,
    onClick: PropTypes.func
};

export default Tag;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/tags/tag.jsx